import { render, staticRenderFns } from "./displayAdvertisingStyle.vue?vue&type=template&id=480d3c70&scoped=true"
import script from "./displayAdvertisingStyle.vue?vue&type=script&lang=js"
export * from "./displayAdvertisingStyle.vue?vue&type=script&lang=js"
import style0 from "./displayAdvertisingStyle.vue?vue&type=style&index=0&id=480d3c70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480d3c70",
  null
  
)

export default component.exports